import { Box, Card, CardContent, CardCover } from '@mui/joy';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';

// Image preview with a remove button that reveals on hover. Shared by
// FormImage's single preview and FormImages' sortable tiles.
export function ImageThumbnailCard({ url, alt, onRemove, sx }) {
  return (
    <Card sx={{ width: { xs: '150px', sm: '200px' }, height: { xs: '125px', sm: '166px' }, ...sx }}>
      <CardCover>
        <img src={url} alt={alt} />
      </CardCover>
      <CardContent sx={{ m: -1, opacity: 0, '&:hover': { opacity: 1 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <RemoveFormElementButton onClick={onRemove} size="sm" color="danger" variant="solid" sx={{ borderRadius: '50%' }} />
        </Box>
      </CardContent>
    </Card>
  );
}
